// Styles
import './Header.css'

// Components
import Navbar from '../Navbar/Navbar'

const Header = () => {
  return (
    <div className="header">
      <Navbar />
    </div>
  )
}

export default Header
